( function () {
	'use strict';

	/**
	 * Catalogue page (t_catalogue.php): filter, count and paginate in the browser.
	 *
	 * The server renders the first view from the catalogue index; this script
	 * loads the same index and updates that markup in place, so changing a
	 * filter needs no request to WordPress. Rules mirror
	 * functions/catalogue-page.php:
	 * - values within a filter are alternatives (OR); different filters combine (AND);
	 * - a category also matches products in its subcategories;
	 * - each option's count assumes the other filters stay as they are.
	 * If the index cannot be loaded, the filter form submits normally.
	 */
	var root = document.querySelector( '[data-folis-catalogue]' );
	if ( ! root || ! window.fetch || ! window.history.pushState ) {
		return;
	}

	var config = JSON.parse( root.getAttribute( 'data-folis-catalogue' ) );
	var base = root.getAttribute( 'data-base-url' );
	var form = root.querySelector( '[data-catalogue-filters]' );
	var grid = root.querySelector( '[data-catalogue-grid]' );
	var countNode = root.querySelector( '[data-catalogue-count]' );
	var chipsNode = root.querySelector( '[data-catalogue-chips]' );
	var pagination = root.querySelector( '[data-catalogue-pagination]' );
	var cardTemplate = root.querySelector( '[data-catalogue-card]' );
	var toggle = root.querySelector( '[data-catalogue-toggle]' );
	var facets = {};
	var products = [];
	var expanded = {};
	var current = { selection: {}, page: 1 };
	var failed = false;

	var ready = fetch( config.index, { credentials: 'omit' } )
		.then( function ( response ) {
			if ( ! response.ok ) {
				throw new Error( 'Catalogue index unavailable' );
			}
			return response.json();
		} )
		.then( function ( index ) {
			prepare( index );
			current = fromUrl( window.location.href );
			root.setAttribute( 'data-ready', '' );
			if ( toggle ) {
				toggle.hidden = false;
			}
			form.querySelector( '[data-catalogue-apply]' ).hidden = true;
		} )
		.catch( function () {
			failed = true;
		} );

	function prepare( index ) {
		products = index.products;
		// Category and brand pages show only that term's products (see folis_catalogue_apply_scope()).
		var scope = config.scope && buildFacet( index, config.scope.taxonomy );
		if ( scope ) {
			products = products.filter( function ( product ) {
				return matches( product, scope, [ config.scope.term ] );
			} );
		}
		config.facets.forEach( function ( taxonomy ) {
			var facet = buildFacet( index, taxonomy );
			if ( facet ) {
				facet.fieldset = form.querySelector( '[data-facet="' + taxonomy + '"]' );
				if ( scope && taxonomy === config.scope.taxonomy ) {
					// On a category page, only its subcategories can be selected.
					Object.keys( facet.slugs ).forEach( function ( slug ) {
						if ( facet.descendants[ config.scope.term ].indexOf( facet.slugs[ slug ] ) < 0 ) {
							delete facet.slugs[ slug ];
						}
					} );
				}
				facets[ taxonomy ] = facet;
			}
		} );
	}

	function buildFacet( index, taxonomy ) {
		var source = index.taxonomies[ taxonomy ];
		if ( ! source ) {
			return null;
		}
		var terms = {};
		var slugs = {};
		var children = {};
		source.terms.forEach( function ( term ) {
			terms[ term.id ] = term;
			slugs[ term.slug ] = term.id;
		} );
		var hierarchical = 'product_cat' === taxonomy;
		source.terms.forEach( function ( term ) {
			var parent = hierarchical && terms[ term.parent ] ? term.parent : 0;
			( children[ parent ] = children[ parent ] || [] ).push( term.id );
		} );
		var descendants = {};
		function collect( id ) {
			var all = [];
			( children[ id ] || [] ).forEach( function ( child ) {
				all.push( child );
				all = all.concat( collect( child ) );
			} );
			descendants[ id ] = all;
			return all;
		}
		Object.keys( terms ).forEach( function ( id ) {
			if ( ! descendants[ id ] ) {
				collect( Number( id ) );
			}
		} );
		return {
			taxonomy: taxonomy,
			param: source.param,
			attribute: 0 === source.param.indexOf( 'filter_' ),
			hierarchical: hierarchical,
			terms: terms,
			slugs: slugs,
			descendants: descendants,
		};
	}

	function fromUrl( href ) {
		var params = new URL( href ).searchParams;
		var selection = {};
		Object.keys( facets ).forEach( function ( taxonomy ) {
			var facet = facets[ taxonomy ];
			var values = [];
			params.getAll( facet.param ).concat( params.getAll( facet.param + '[]' ) ).forEach( function ( value ) {
				values = values.concat( value.split( ',' ) );
			} );
			var ids = [];
			values.forEach( function ( slug ) {
				var id = facet.slugs[ slug.trim() ];
				if ( id && ids.indexOf( id ) < 0 ) {
					ids.push( id );
				}
			} );
			if ( ids.length ) {
				selection[ taxonomy ] = ids;
			}
		} );
		return { selection: selection, page: Math.max( 1, parseInt( params.get( 'pagina' ), 10 ) || 1 ) };
	}

	function fromForm() {
		var selection = {};
		Object.keys( facets ).forEach( function ( taxonomy ) {
			var facet = facets[ taxonomy ];
			var ids = [];
			facet.fieldset.querySelectorAll( 'input:checked' ).forEach( function ( input ) {
				var id = facet.slugs[ input.value ];
				if ( id ) {
					ids.push( id );
				}
			} );
			if ( ids.length ) {
				selection[ taxonomy ] = ids;
			}
		} );
		return selection;
	}

	function urlFor( selection, page ) {
		var url = new URL( base );
		Object.keys( facets ).forEach( function ( taxonomy ) {
			var facet = facets[ taxonomy ];
			var ids = selection[ taxonomy ];
			if ( ! ids || ! ids.length ) {
				return;
			}
			url.searchParams.set( facet.param, ids.map( function ( id ) { return facet.terms[ id ].slug; } ).join( ',' ) );
			if ( facet.attribute ) {
				url.searchParams.set( 'query_type_' + facet.param.slice( 7 ), 'or' );
			}
		} );
		if ( page > 1 ) {
			url.searchParams.set( 'pagina', String( page ) );
		}
		return url.toString();
	}

	function matches( product, facet, selected ) {
		var assigned = product.t[ facet.taxonomy ] || [];
		return selected.some( function ( id ) {
			return assigned.indexOf( id ) >= 0 || facet.descendants[ id ].some( function ( child ) {
				return assigned.indexOf( child ) >= 0;
			} );
		} );
	}

	function apply( selection ) {
		var found = [];
		var counts = {};
		var chosen = Object.keys( selection );
		products.forEach( function ( product ) {
			var failedFacets = chosen.filter( function ( taxonomy ) {
				return ! matches( product, facets[ taxonomy ], selection[ taxonomy ] );
			} );
			if ( ! failedFacets.length ) {
				found.push( product );
			}
			Object.keys( facets ).forEach( function ( taxonomy ) {
				if ( failedFacets.length && ( failedFacets.length > 1 || failedFacets[ 0 ] !== taxonomy ) ) {
					return;
				}
				var facet = facets[ taxonomy ];
				var credited = {};
				( product.t[ taxonomy ] || [] ).forEach( function ( id ) {
					credited[ id ] = true;
					if ( facet.hierarchical ) {
						var parent = facet.terms[ id ] ? facet.terms[ id ].parent : 0;
						while ( parent && facet.terms[ parent ] ) {
							credited[ parent ] = true;
							parent = facet.terms[ parent ].parent;
						}
					}
				} );
				counts[ taxonomy ] = counts[ taxonomy ] || {};
				Object.keys( credited ).forEach( function ( id ) {
					counts[ taxonomy ][ id ] = ( counts[ taxonomy ][ id ] || 0 ) + 1;
				} );
			} );
		} );
		return { products: found, counts: counts };
	}

	function renderFacets( selection, counts ) {
		Object.keys( facets ).forEach( function ( taxonomy ) {
			var facet = facets[ taxonomy ];
			var chosen = selection[ taxonomy ] || [];
			var facetCounts = counts[ taxonomy ] || {};
			var shown = 0;
			facet.fieldset.querySelectorAll( '[data-term]' ).forEach( function ( item ) {
				var id = Number( item.getAttribute( 'data-term' ) );
				var count = facetCounts[ id ] || 0;
				var selected = chosen.indexOf( id ) >= 0;
				var available = count > 0 || selected;
				var overflow = available && ++shown > config.visibleOptions;
				item.hidden = ! available || ( overflow && ! expanded[ taxonomy ] );
				item.querySelector( 'input' ).checked = selected;
				item.querySelector( '[data-count]' ).textContent = '(' + count + ')';
			} );
			// Hide the whole filter, title included, when it has no options to offer.
			facet.fieldset.hidden = 0 === shown;
			var more = facet.fieldset.querySelector( '[data-show-more]' );
			more.hidden = shown <= config.visibleOptions;
			more.textContent = expanded[ taxonomy ] ? config.text.less : config.text.more;
			more.setAttribute( 'aria-expanded', expanded[ taxonomy ] ? 'true' : 'false' );
		} );
	}

	function renderChips( selection ) {
		var fragment = document.createDocumentFragment();
		Object.keys( selection ).forEach( function ( taxonomy ) {
			selection[ taxonomy ].forEach( function ( id ) {
				var name = facets[ taxonomy ].terms[ id ].name;
				var chip = document.createElement( 'a' );
				chip.className = 'inline-flex min-h-9 items-center gap-2 rounded-full border border-solid border-slate-300 bg-surface px-3 text-sm text-ink no-underline hover:border-brand';
				chip.href = urlFor( without( selection, taxonomy, id ), 1 );
				chip.setAttribute( 'data-remove', taxonomy + ':' + id );
				chip.setAttribute( 'aria-label', config.text.remove.replace( '%s', name ) );
				chip.textContent = name + ' ';
				var cross = document.createElement( 'span' );
				cross.setAttribute( 'aria-hidden', 'true' );
				cross.textContent = '×';
				chip.appendChild( cross );
				fragment.appendChild( chip );
			} );
		} );
		if ( Object.keys( selection ).length ) {
			var clear = document.createElement( 'a' );
			clear.className = 'inline-flex min-h-9 items-center px-2 text-sm font-semibold text-brand';
			clear.href = base;
			clear.setAttribute( 'data-remove', 'all' );
			clear.textContent = 'Limpar filtros';
			fragment.appendChild( clear );
		}
		chipsNode.replaceChildren( fragment );
	}

	function card( product ) {
		var item = cardTemplate.content.firstElementChild.cloneNode( true );
		var image = item.querySelector( '[data-card-image]' );
		var img = product.img;
		item.querySelector( '[data-card-link]' ).href = product.url;
		var title = item.querySelector( '[data-card-title]' );
		title.href = product.url;
		title.textContent = product.name;
		if ( img ) {
			image.src = img.src;
			image.width = img.w;
			image.height = img.h;
			image.alt = img.alt;
			if ( img.srcset ) {
				image.srcset = img.srcset;
				image.sizes = img.sizes;
			} else {
				image.removeAttribute( 'srcset' );
				image.removeAttribute( 'sizes' );
			}
		} else {
			image.remove();
		}
		var details = item.querySelector( '[data-card-details]' );
		details.href = product.url;
		details.setAttribute( 'data-folis-product-details', String( product.id ) );
		details.setAttribute( 'data-folis-details-url', product.d && config.detailsFiles ? config.detailsFiles + product.d : config.details + product.id );
		item.querySelector( '[data-card-actions]' ).hidden = ! product.details;
		return item;
	}

	function renderPagination( selection, page, pages ) {
		var fragment = document.createDocumentFragment();
		for ( var number = 1; pages > 1 && number <= pages; number++ ) {
			var link = document.createElement( 'a' );
			var active = number === page;
			link.className = 'inline-flex h-11 min-w-11 items-center justify-center rounded border border-solid px-3 font-semibold no-underline ' + ( active ? 'border-brand bg-brand text-white' : 'border-slate-300 text-ink hover:border-brand' );
			link.href = urlFor( selection, number );
			link.setAttribute( 'data-page', String( number ) );
			if ( active ) {
				link.setAttribute( 'aria-current', 'page' );
			}
			link.textContent = String( number );
			fragment.appendChild( link );
		}
		pagination.replaceChildren( fragment );
	}

	function render( state ) {
		var result = apply( state.selection );
		var total = result.products.length;
		var pages = Math.max( 1, Math.ceil( total / config.perPage ) );
		var page = Math.min( pages, state.page );
		current = { selection: state.selection, page: page };
		renderFacets( state.selection, result.counts );
		renderChips( state.selection );
		countNode.textContent = total ? ( 1 === total ? config.text.one : config.text.many.replace( '%d', total ) ) : config.text.none;
		var fragment = document.createDocumentFragment();
		result.products.slice( ( page - 1 ) * config.perPage, page * config.perPage ).forEach( function ( product ) {
			fragment.appendChild( card( product ) );
		} );
		grid.replaceChildren( fragment );
		renderPagination( state.selection, page, pages );
	}

	function navigate( state, scroll ) {
		render( state );
		window.history.pushState( null, '', urlFor( current.selection, current.page ) );
		if ( scroll ) {
			var top = grid.parentNode.getBoundingClientRect().top;
			if ( top < 0 ) {
				grid.parentNode.scrollIntoView( { block: 'start' } );
			}
		}
	}

	function without( selection, taxonomy, id ) {
		var copy = {};
		Object.keys( selection ).forEach( function ( key ) {
			var ids = key === taxonomy ? selection[ key ].filter( function ( other ) { return other !== id; } ) : selection[ key ];
			if ( ids.length ) {
				copy[ key ] = ids;
			}
		} );
		return copy;
	}

	form.addEventListener( 'change', function () {
		ready.then( function () {
			if ( failed ) {
				form.submit();
				return;
			}
			navigate( { selection: fromForm(), page: 1 }, false );
		} );
	} );
	form.addEventListener( 'submit', function ( event ) {
		if ( ! failed && root.hasAttribute( 'data-ready' ) ) {
			event.preventDefault();
			navigate( { selection: fromForm(), page: 1 }, false );
		}
	} );
	form.addEventListener( 'click', function ( event ) {
		var more = event.target.closest( '[data-show-more]' );
		if ( ! more || ! root.hasAttribute( 'data-ready' ) ) {
			return;
		}
		var taxonomy = more.closest( '[data-facet]' ).getAttribute( 'data-facet' );
		expanded[ taxonomy ] = ! expanded[ taxonomy ];
		renderFacets( current.selection, apply( current.selection ).counts );
	} );
	root.addEventListener( 'click', function ( event ) {
		if ( ! root.hasAttribute( 'data-ready' ) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ) {
			return;
		}
		var chip = event.target.closest( '[data-remove]' );
		var pageLink = event.target.closest( '[data-page]' );
		if ( chip ) {
			event.preventDefault();
			var target = chip.getAttribute( 'data-remove' );
			var parts = target.split( ':' );
			navigate( { selection: 'all' === target ? {} : without( current.selection, parts[ 0 ], Number( parts[ 1 ] ) ), page: 1 }, false );
		} else if ( pageLink ) {
			event.preventDefault();
			navigate( { selection: current.selection, page: Number( pageLink.getAttribute( 'data-page' ) ) }, true );
		}
	} );
	window.addEventListener( 'popstate', function () {
		if ( root.hasAttribute( 'data-ready' ) ) {
			render( fromUrl( window.location.href ) );
		}
	} );
	if ( toggle ) {
		toggle.addEventListener( 'click', function () {
			var open = 'true' !== toggle.getAttribute( 'aria-expanded' );
			toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			form.classList.toggle( 'is-open', open );
		} );
	}
}() );
